exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".CartInfo_CartInfo__pJJ7n{display:-webkit-flex;display:flex;-webkit-align-items:flex-start;align-items:flex-start;-webkit-justify-content:space-between;justify-content:space-between;min-height:50px;padding-top:15px;padding-bottom:15px}.CartInfo_CartInfo__moreItems__2tvxa{color:#9fa0a4;font-size:12px}.CartInfo_CartInfo__total__3MRG7{color:#333;text-align:right}.CartInfo_CartInfo__totalLabel__3HKR8{font-weight:700;font-size:14px}.CartInfo_CartInfo__totalPrice__3QDKA{font-weight:700;font-size:16px}.CartInfo_CartInfo__totalPrice__3QDKA .CartInfo_CartInfo__totalPriceFraction__ATHkj{font-size:14px}", "", {"version":3,"sources":["/apps/jenkins_26112018/jenkins/workspace/migrationBuildUiJob_actual/ui-prototypes/miniCartReminder/src/components/CartInfo/index.scss"],"names":[],"mappings":"AAIA,0BACI,qBAAA,aACA,+BAAA,uBACA,sCAAA,8BACA,gBACA,iBACA,mBAAoB,CAGxB,qCACI,cACA,cAAe,CAGnB,iCACI,WACA,gBAAiB,CAGrB,sCACI,gBACA,cAAe,CAGnB,sCACI,gBACA,cAAe,CAFnB,oFAIQ,cAAe,CAAA","file":"index.scss","sourcesContent":["@import '../../styles/scss/variables';\n@import '../../styles/scss/colors';\n@import '../../styles/scss/_breakpoints';\n\n.CartInfo {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    min-height: 50px;\n    padding-top: 15px;\n    padding-bottom: 15px;\n}\n\n.CartInfo__moreItems {\n    color: $grayLight;\n    font-size: 12px;\n}\n\n.CartInfo__total {\n    color: $textBlack;\n    text-align: right;\n}\n\n.CartInfo__totalLabel {\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.CartInfo__totalPrice {\n    font-weight: bold;\n    font-size: 16px;\n    .CartInfo__totalPriceFraction {\n        font-size: 14px;\n    }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"fontStack": "\"Open Sans\",\"Lucida Grande\",Lucida,\"Lucida Sans Unicode\",sans-serif",
	"containerWidthMain": "960",
	"heightDesktopHeader": "139px",
	"minicartWidth": "350px",
	"minicartTipRightOffsetDesktop": "15px",
	"minicartTipSide": "5px",
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009b29",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333",
	"textGray": "#9b9b9b",
	"textWhite": "#fff",
	"grayLight": "#9fa0a4",
	"CartInfo": "CartInfo_CartInfo__pJJ7n",
	"CartInfo__moreItems": "CartInfo_CartInfo__moreItems__2tvxa",
	"CartInfo__total": "CartInfo_CartInfo__total__3MRG7",
	"CartInfo__totalLabel": "CartInfo_CartInfo__totalLabel__3HKR8",
	"CartInfo__totalPrice": "CartInfo_CartInfo__totalPrice__3QDKA",
	"CartInfo__totalPriceFraction": "CartInfo_CartInfo__totalPriceFraction__ATHkj"
};